var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validator-reward flex-row",class:{
        'dry': _vm.dry,
        'low-reward': !_vm.dry && (_vm.reward * 100) < 2.5,
    }},[_vm._v(" "+_vm._s(_vm.formatted)+"% "+_vm._s(_vm.percentOnly ? '' : _vm.$t('p.a.'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }